"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var angular_cc_library_1 = require("angular-cc-library");
var subscribtion_service_1 = require("../Services/subscribtion.service");
var WickedApiClient_1 = require("../api/WickedApiClient");
var router_1 = require("@angular/router");
var material_1 = require("@angular/material");
var user_service_1 = require("../Services/user.service");
var AuthHeaders_1 = require("../api/AuthHeaders");
var service_service_1 = require("../Services/service.service");
var SubscribtionComponent = /** @class */ (function () {
    function SubscribtionComponent(fb, subscribtionService, router, dialog, userService, mainService) {
        var _this = this;
        this.fb = fb;
        this.subscribtionService = subscribtionService;
        this.router = router;
        this.dialog = dialog;
        this.userService = userService;
        this.mainService = mainService;
        this.enableSubscription = false;
        this.creating = false;
        this.errorMessage = "";
        this.subscribeActionFinished = new core_1.EventEmitter();
        this._isSubscriptionInfo = false;
        this.canShow = false;
        this.showSave = "0";
        this.enableSubscription = mainService.enableSubscription;
        if (!this.enableSubscription) {
            this.router.navigate(['']);
        }
        this.subscribtionService.hasUserSubscribtion().then(function (hasSubscription) {
            _this.subscribtionService.get().then(function (data) {
                var subscribtions = data;
                if (subscribtions.length > 0) {
                    var active = subscribtions.find(function (v) {
                        return v.status == WickedApiClient_1.Status.Active;
                    });
                    if (active != undefined) {
                        //this.userHasActiveSubscription = true;
                        if (_this.router.url == "/subscribtion") {
                            _this.router.navigate(['/subscription-information']);
                        }
                    }
                    else {
                        _this.canShow = true;
                    }
                }
                else {
                    _this.canShow = true;
                }
            });
        });
    }
    SubscribtionComponent.prototype.valueChanged = function () {
        this.subscribeActionFinished.emit(true);
    };
    Object.defineProperty(SubscribtionComponent.prototype, "isSubscriptionInfo", {
        get: function () {
            return this._isSubscriptionInfo;
        },
        set: function (value) {
            this._isSubscriptionInfo = value;
        },
        enumerable: true,
        configurable: true
    });
    SubscribtionComponent.prototype.ngOnInit = function () {
        this.form = this.fb.group({
            firstName: ['', [forms_1.Validators.required]],
            lastName: ['', [forms_1.Validators.required]],
            zip: ['', [forms_1.Validators.required]],
            creditCard: ['', [angular_cc_library_1.CreditCardValidator.validateCCNumber]],
            expirationDateYear: ['', [forms_1.Validators.required]],
            expirationDateMonth: ['', [forms_1.Validators.required]],
            cvc: ['', [forms_1.Validators.required, forms_1.Validators.minLength(3), forms_1.Validators.maxLength(4)]],
            subscriptionPeriod: ['']
        });
    };
    Object.defineProperty(SubscribtionComponent.prototype, "submitButtonText", {
        get: function () {
            if (this.form && Number(this.form.controls["subscriptionPeriod"].value) == WickedApiClient_1.Period.SinglePremiumAd) {
                return "ADD ONE CREDIT";
            }
            return "SUBSCRIBE NOW";
        },
        enumerable: true,
        configurable: true
    });
    SubscribtionComponent.prototype.onSubmit = function () {
        var _this = this;
        console.log("submit");
        if (this.creating)
            return;
        var subscribe = new WickedApiClient_1.Subscribe({
            firstName: this.form.controls["firstName"].value,
            lastName: this.form.controls["lastName"].value,
            cardNumber: this.form.controls["creditCard"].value,
            expirationDate: this.form.controls["expirationDateYear"].value + "-" + this.form.controls["expirationDateMonth"].value,
            zip: this.form.controls["zip"].value,
            securityCode: this.form.controls["cvc"].value,
            period: Number(this.form.controls["subscriptionPeriod"].value)
        });
        if (this.form.dirty && this.form.valid) {
            if (Number(this.form.controls["subscriptionPeriod"].value) == WickedApiClient_1.Period.SinglePremiumAd) {
                this.creating = true;
                var tokenRequest = new WickedApiClient_1.AddPremiumAdToken({
                    cardNumber: subscribe.cardNumber,
                    firstName: subscribe.firstName,
                    lastName: subscribe.lastName,
                    expirationDate: subscribe.expirationDate,
                    zip: subscribe.zip,
                    securityCode: subscribe.securityCode,
                });
                this.subscribtionService.createPremiumAdToken(tokenRequest).then(function (response) {
                    if (response.isError) {
                        console.log('asd');
                        _this.errorMessage = response.message;
                        _this.mainService.showError(_this.errorMessage);
                    }
                    else {
                        _this.router.navigate(['/adv-create']);
                        _this.valueChanged();
                    }
                    _this.creating = false;
                });
            }
            else {
                this.creating = true;
                this.subscribtionService.create(subscribe).then(function (response) {
                    if (response.isError) {
                        console.log("errorek");
                        _this.errorMessage = response.message;
                        _this.mainService.showError(_this.errorMessage);
                        //this.dialog.open(this.errorDialog);
                    }
                    else {
                        if (response.isCreated) {
                            AuthHeaders_1.setAuthToken(response.token);
                        }
                        _this.router.navigate(['/subscription-information']);
                        _this.valueChanged();
                    }
                    _this.creating = false;
                });
            }
            // .finally(() => {
            //     this.creating = false;
            // });
        }
    };
    SubscribtionComponent.prototype.show = function (e) {
        if (e.value == "1") {
            this.showSave = "1";
        }
        else if (e.value == "2") {
            this.showSave = "2";
        }
        else {
            this.showSave = "";
        }
    };
    return SubscribtionComponent;
}());
exports.SubscribtionComponent = SubscribtionComponent;
